import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import {createFundamentalMarker} from "#template/role-markers"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {ObjectLikeNode} from "#template/nodes/object/fundamental"
import type {CurveObjectData} from "#template/nodes/object/curve/types"

export const curveLikeMarker = Symbol("CurveLike")

// `evaluate` is redeclared to narrow the return type from `ObjectData | null` to `CurveObjectData |
// null`. See `MeshLikeNode` for the same pattern + the TS2320 explanation.
export interface CurveLikeNode extends ObjectLikeNode {
    readonly [curveLikeMarker]: true
    evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<CurveObjectData | null>
}

export const curveMarker = createFundamentalMarker<CurveLikeNode>(curveLikeMarker)
export const {isLikeNode: isCurveLikeNode, isLikeNodeClass: isCurveLikeNodeClass, like: curveLike} = curveMarker
